import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { gateway_recommendation_type } from "../../enums";
import {
  useAccountSettings,
  useHookForm,
  useMerchantApiMutation,
} from "../../hooks";
import { IBrandingSettings } from "../../interfaces-and-types";
import { convertObjectToFormData, globalHandlerUtils } from "../../utils";
import { brandingValidationSchema } from "./validationSchema";

import { View } from "./View";

export const Branding = () => {
  const navigate = useNavigate();

  const {
    // isLoading: isLoadingAccountSettings,
    isSuccess: isSuccessAccountSettings,
    data: accountSettings,
    refreshRemoteData: refreshAccountSettings,
  } = useAccountSettings();

  useEffect(() => {
    accountSettings && reset(accountSettings);
  }, []);

  useEffect(() => {
    if (isSuccessAccountSettings) {
      // console.log("resetting the form...");
      accountSettings && reset(accountSettings);

      accountSettings &&
        setLogoActualImage(accountSettings?.merchant_logo ?? undefined);
    }
  }, [isSuccessAccountSettings]);

  const initialFormValues: IBrandingSettings = {
    accent_color: null,
    brand_color: null,
    text_color: null,

    // ...accountSettings,
  };

  const { isSuccess: isSuccessSaveSettings, mutate: saveSettings } =
    useMerchantApiMutation</*IBrandingSettings*/ FormData, IBrandingSettings>(
      "saveBrandingSettings"
    ).usePutMutation;

  const handleApiSubmit = (data: IBrandingSettings) => {
    const stateAsFormData = convertObjectToFormData(initialFormValues, data, [
      { uploadFileName: "merchant_logo", file: merchant_logoFile },
    ]);

    saveSettings(stateAsFormData);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, control, reset } =
    useHookForm({
      initialFormValues,
      validationSchema: brandingValidationSchema,
      onValid: handleApiSubmit,
      onInvalid: handleError,
    });

  useEffect(() => {
    if (isSuccessSaveSettings) {
      refreshAccountSettings();
    }
  }, [isSuccessSaveSettings]);

  const goBack = () => navigate("/settings");

  const [merchant_logoFile, setMerchantLogoFile] = useState<File | null>(null);
  const [logoActualImage, setLogoActualImage] = useState<string | undefined>(
    undefined
  );

  const saveMerchantLogo = (e: React.ChangeEvent<HTMLInputElement>) => {
    let reader = new FileReader();
    reader.onload = function (event: any) {
      setLogoActualImage(event.target.result);
    };
    if (e.target.files && e.target.files[0]) {
      setMerchantLogoFile(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
      document
        .querySelector(".image-previewer")!
        .classList.add("remove-border");
    }
  };

  return (
    <View
      goBack={goBack}
      isDirty={isDirty}
      logoActualImage={logoActualImage}
      saveMerchantLogo={saveMerchantLogo}
      control={control}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
